<div *renderInProductResult="LayoutTargets.Actions" add-to-cart [attr.layout]="layout()">
  <ideal-cart-item-quantity-selector [itemId]="itemId()" />
</div>
